<div class="row mx-0 p-3 px-md-5 g-3 gy-md-0 justify-content-between">
    <div class="col-12 col-md-auto d-flex align-items-center">
        <span class="notranslate">{{selectedItems.length}}</span>
        <span class="notranslate">&nbsp;</span>
        <span>selected</span>
    </div>
    <div class="col-md-auto ms-auto">
        <button class="btn btn-outline-danger mx-1 w-100" (click)="cancelMethod()" type="button">
            Cancel
        </button>
    </div>
    <div class="col-md-auto" *ngIf="hasAnyMutedAlert">
        <button class="btn btn-outline-info mx-1 w-100" (click)="unmuteAlerts()" type="button">
            Unmute alerts
        </button>
    </div>
    <div class="col-md-auto" *ngIf="hasAnyResolvedAlert">
        <button class="btn btn-outline-info mx-1 w-100" (click)="reopenAlerts()" type="button">
            Reopen alerts
        </button>
    </div>
    <div class="col-md-auto" *ngIf="hasAnyOpenAlert">
        <button class="btn btn-outline-info mx-1 w-100" (click)="muteAlerts()" type="button">
            Mute alerts
        </button>
    </div>
    <div class="col-md-auto">
        <button class="btn btn-outline-info mx-1 w-100" (click)="resolveAlerts()" type="button">
            Resolve alerts
        </button>
    </div>
</div>


<ng-template #muteAlertTemplate>
    <p>
        <span>You are about to mute</span>
        <span class="notranslate fw-bold"> {{selectedItems.length}} </span>
        <span>bulk mute alerts</span>
    </p>
    <p class="fw-bold">Are you sure you want to execute this action?</p>
    <app-form-field label="Mute deadline">
        <app-date-field [(ngModel)]="muteDate" [minDate]="tomorrow()"></app-date-field>
    </app-form-field>
</ng-template>
